import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const PROJECT_ID = "wordgame416";
const ADD_SCORE_FUNCTION_URL = `https://us-central1-${PROJECT_ID}.cloudfunctions.net/addLeaderboardScore`;

// export const testFunc = () => {
//   const alpha = Array.from(Array(26)).map((e, i) => i + 65);
//   const sortedAlphabet = alpha.map((x) => String.fromCharCode(x));

//   const shuffle = (array) => {
//     let currentIndex = array.length,
//       randomIndex;
//     while (currentIndex !== 0) {
//       randomIndex = Math.floor(Math.random() * currentIndex);
//       currentIndex--;
//       [array[currentIndex], array[randomIndex]] = [
//         array[randomIndex],
//         array[currentIndex],
//       ];
//     }
//     return array;
//   };

//   // Always have empty string at [0] so lowest letter point is 1
//   const randomizedAlphabet = ["", ...shuffle(sortedAlphabet)];

//   console.log(randomizedAlphabet);
// };

export const getInitialData = async () => {
  const settingsRef = doc(db, "game", "settings");
  const settingsSnap = await getDoc(settingsRef);
  const statsRef = doc(db, "game", "stats");
  const statsSnap = await getDoc(statsRef);

  const data = {};

  if (settingsSnap.exists()) {
    const settings = settingsSnap.data();
    data.letterValues = settings.letterValues;
  }
  if (statsSnap.exists()) {
    const stats = statsSnap.data();
    data.wfVersion = stats.wfVersion;
  }

  return data;
};

export const setHighScore = async () => {};

export const getHighScore = async () => {
  const statsRef = doc(db, "game", "stats");
  const statsSnap = await getDoc(statsRef);

  const data = {};

  if (statsSnap.exists()) {
    const stats = statsSnap.data();
    data.highestScore = stats.highestScore;
    data.highestScoreWords = stats.highestScoreWords;
  }

  return data;
};

export const getAllScores = async () => {
  const scoresRef = doc(db, "game", "scores");
  const scoresSnap = await getDoc(scoresRef);

  let scores = null;

  if (scoresSnap.exists()) {
    scores = scoresSnap.data().scores;
  }

  return scores;
};

export const addScoreToLeaderboard = async (score, name, words) => {
  const normalizedWords = words.map((word) =>
    Array.isArray(word) ? word.join("").toLowerCase() : String(word).toLowerCase()
  );

  const response = await fetch(ADD_SCORE_FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      score,
      words: normalizedWords,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.error || "request_failed");
    error.code = data?.error || "request_failed";
    throw error;
  }

  return data;
};
